import ActivityLogList from './ActivityLogList';

export default ActivityLogList;
